import { TFunction } from 'next-i18next'

import { intersection } from '@src/utils/functions/utils'

import { InvalidAddressReasonType } from './addressType'

const UNDELIVERABLE_ERROR_CODES = ['D_3001', 'D_3002', 'D_3003']

/* eslint-disable i18next/no-literal-string -- API error codes, not user-facing text */
const GENERAl_INVALID_ADDRESS_CODES = [
  'V_4001',
  'V_4002',
  'V_1001',
  'V_1002',
  'V_1003',
  'V_1004',
  'V_1005',
  'V_1006',
  'UNKNOWN',
]
/* eslint-enable i18next/no-literal-string */

export const getErrorStates = (invalidAddressReasons: InvalidAddressReasonType[], t: TFunction) => {
  const ADDRESS_FIELD_INVALID_ERROR_CODE_MAP: Record<
    string,
    {
      fieldKey: string
      errorMsg: string
    }
  > = {
    V_1001: {
      // @i18n-ignore
      fieldKey: 'address1',
      errorMsg: t('enter_a_valid_address'),
    },
    V_1002: {
      // @i18n-ignore
      fieldKey: 'provinceCode',
      errorMsg: t('enter_a_valid_state_for_city_zip'),
    },
    V_1003: {
      // @i18n-ignore
      fieldKey: 'city',
      errorMsg: t('enter_a_valid_city'),
    },
    V_1004: {
      // @i18n-ignore
      fieldKey: 'zip',
      errorMsg: t('enter_a_valid_zip_code'),
    },
    V_1005: {
      // @i18n-ignore
      fieldKey: 'address2',
      errorMsg: t('enter_a_valid_address_v1'),
    },
    V_1006: {
      // @i18n-ignore
      fieldKey: 'country',
      errorMsg: t('enter_a_valid_country'),
    },
  }

  const errorCodes = invalidAddressReasons.map(reason => reason.code)
  const fieldErrorMap = errorCodes.reduce((acc, errorCode) => {
    if (Object.prototype.hasOwnProperty.call(ADDRESS_FIELD_INVALID_ERROR_CODE_MAP, errorCode)) {
      const errorObject = ADDRESS_FIELD_INVALID_ERROR_CODE_MAP[errorCode]
      if (errorObject) {
        return { ...acc, [errorObject.fieldKey]: { message: errorObject.errorMsg } }
      }
    }
    return acc
  }, {})
  return {
    isAddressDelieverable: intersection(errorCodes, UNDELIVERABLE_ERROR_CODES).length === 0,
    hasGeneralInvalidAddressCode: intersection(errorCodes, GENERAl_INVALID_ADDRESS_CODES).length > 0,
    fieldErrorMap,
  }
}
